<template>
	<div
		v-if="contentSectionTop !== null"
		id="test-ad"
		class="ad-container"
		:style="adPositionStyle"
	/>
</template>

<script>
export default {
	name: 'AdContainer',
	data() {
		return {
			contentSectionTop:    null,
			intersectionObserver: null,
			resizeTimeout:        null,
			scrollTimeout:        null,
			isSticky:             false,
		};
	},
	computed: {
		adTopPosition() {
			if (!this.contentSectionTop) return 0;

			if (this.isSticky) {
				// When sticky, position at top of viewport
				return 0;
			} else {
				// When not sticky, position at content section
				return this.contentSectionTop;
			}
		},
		adPositionStyle() {
			if (!this.contentSectionTop) return {};

			return {
				position: this.isSticky ? 'fixed' : 'absolute',
				top:      this.adTopPosition + 'px',
			};
		},
	},
	mounted() {
		this.setAdPosition();
		this.setupIntersectionObserver();
		// Throttled resize listener
		window.addEventListener('resize', this.handleResize);
		// Scroll listener for sticky behavior
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		if (this.intersectionObserver) {
			this.intersectionObserver.disconnect();
		}
		if (this.resizeTimeout) {
			clearTimeout(this.resizeTimeout);
		}
		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		setAdPosition() {
			const contentSection = document.querySelector('.js-content-section');
			if (contentSection) {
				this.contentSectionTop = contentSection.offsetTop;
			} else {
				this.contentSectionTop = null;
			}
		},
		setupIntersectionObserver() {
			// Only observe the content section, not the entire document
			const contentSection = document.querySelector('.js-content-section');
			if (!contentSection) return;

			this.intersectionObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						// When content section enters viewport, update position
						if (entry.isIntersecting) {
							this.setAdPosition();
						}
					});
				},
				{
					// Trigger when content section is near viewport
					rootMargin: '100px 0px 0px 0px',
					threshold:  0,
				}
			);

			this.intersectionObserver.observe(contentSection);
		},
		handleResize() {
			// Throttle resize events to improve performance
			if (this.resizeTimeout) {
				clearTimeout(this.resizeTimeout);
			}
			this.resizeTimeout = setTimeout(() => {
				this.setAdPosition();
			}, 100); // Only recalculate after 100ms of no resize
		},
		handleScroll() {
			// Throttle scroll events for better performance
			if (this.scrollTimeout) {
				clearTimeout(this.scrollTimeout);
			}
			this.scrollTimeout = setTimeout(() => {
				this.updateStickyPosition();
			}, 16); // ~60fps
		},
		updateStickyPosition() {
			if (!this.contentSectionTop) return;

			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const shouldBeSticky = scrollTop >= this.contentSectionTop;

			if (shouldBeSticky !== this.isSticky) {
				this.isSticky = shouldBeSticky;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.ad-container {
	@include z-index(arena-ad-container);
	position: absolute; // Default position, will be overridden by dynamic :style binding
	left: 1300px;
	width: 300px;
	height: 600px;
	margin-top: 20px;
	display: none;

	@media only screen and (min-width: 1440px) {
		display: block;
		left: 1160px;
	}
	@media only screen and (min-width: 1680px) {
		left: 1300px;
	}
}
</style>
